import { useState, useRef, useCallback } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  Autocomplete,
} from "@react-google-maps/api";
import axios from "axios";
import { useUserAuth } from "../context/UserAuthContext";

const containerStyle = {
  width: "100%",
  height: "400px",
};

const libraries = ["places"];

const  BusinessMap = () => {
      const { user } = useUserAuth();
        const merchant_id = user?.uid;
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyCuMfYccbSV9mktbfpt22RsFd_UqA6g0Sg",
    libraries
  });
const defaultCenter = {
  lat: 26.849969863305358,
  lng: 80.99606323234302,
};
  const [position, setPosition] = useState(defaultCenter);
  const [address, setAddress] = useState("");

  const autocompleteRef = useRef(null);
  const mapRef = useRef(null);

  const onLoadMap = useCallback((map) => {
    mapRef.current = map;
  }, []);

  const onPlaceChanged = () => {
    const place = autocompleteRef.current.getPlace();

    if (!place || !place.geometry) return;

    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();

    const newPosition = { lat, lng };

    setPosition(newPosition);
    setAddress(place.formatted_address);
    console.log('place.formatted_address',place)
    // mapRef.current.panTo(newPosition);
  };

const handleMarkerDrag = (e) => {
  const lat = e.latLng.lat();
  const lng = e.latLng.lng();

  const newPosition = { lat, lng };
  setPosition(newPosition);

  const geocoder = new window.google.maps.Geocoder();

  geocoder.geocode({ location: newPosition }, (results, status) => {
    if (status === "OK" && results[0]) {
      setAddress(results[0].formatted_address);
    } else {
      console.error("Geocoder failed due to: " + status);
    }
  });
};


  const getCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const newPosition = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };

        setPosition(newPosition);
        mapRef.current.panTo(newPosition);
      },
      (err) => {
        alert("Location permission denied");
        console.log("error",err)
      }
    );
  };

  const handleSave = async () => {
    await axios.post(`${base_url}/api/v1/vendors/save-location`, {
        latitude: position.lat,
        longitude: position.lng,
        address: address,
        vendor_id: merchant_id,
      })

    alert("Location Saved Successfully");
  };

  if (!isLoaded) return <div>Loading Map...</div>;
console.log("Marker Position:", position);
  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">

            <Autocomplete
              onLoad={(auto) => (autocompleteRef.current = auto)}
              onPlaceChanged={onPlaceChanged}
            >
              <input
                type="text"
                placeholder="Search address"
                style={{ width: "100%", height: "40px", marginBottom: "10px" }}
                className="form-control"
              />
            </Autocomplete>

            <button onClick={getCurrentLocation} style={{ marginBottom: "10px" }} className="btn btn-sm btn-primary">
              Use Current Location
            </button>

           <GoogleMap
            mapContainerStyle={containerStyle}
            zoom={15}
            center={position}
            onLoad={onLoadMap}
            >
            <Marker
                key={`${position.lat}-${position.lng}`}
                position={position}
                draggable
                onDragEnd={handleMarkerDrag}
            />
            </GoogleMap>


            <button
              onClick={handleSave}
              style={{ marginTop: "10px" }}
              className="btn btn-sm btn-primary"
            >
              Save Location
            </button>

          </div>
        </div>
      </div>
    </div>
  );
}

export default BusinessMap;
